// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"d7efd241","466":"ee196981","787":"bd18b08a","983":"83a38a09"}[chunkId] + ".chunk.js";
};